import { AddressDtoAddressType, PatientAddressDtoReferenceType } from '../api/generated/model';

export function getAddressTypeName(type: AddressDtoAddressType) {
  switch (type) {
    case AddressDtoAddressType.CONFIDANT:
      return 'Vertrauensperson';
    case AddressDtoAddressType.RELATIVE:
      return 'Verwandter';
    case AddressDtoAddressType.REFERRER:
      return 'Zuweiser';
    case AddressDtoAddressType.DOT_EXECUTOR:
      return 'DOT Durchführer';
    case AddressDtoAddressType.DOT_APPLICANT:
      return 'DOT Auftraggeber';
    case AddressDtoAddressType.ACCOMMODATION_PRIVATE:
      return 'Privatadresse';
    case AddressDtoAddressType.ACCOMMODATION_ASYLUM:
      return 'Asylzentrum';
    case AddressDtoAddressType.WELFARE_AGENCY:
      return 'Sozialamt';
    case AddressDtoAddressType.HOSPITAL:
      return 'Krankenhaus';
    case AddressDtoAddressType.DOCTOR:
      return 'Arzt';
    case AddressDtoAddressType.INSURANCE:
      return 'Versicherung';
    case AddressDtoAddressType.TB_MEDICAL_CENTER:
      return 'Medizinisches Zentrum (TB)';
    case AddressDtoAddressType.PHARMACY:
      return 'Apotheke';
    case AddressDtoAddressType.LAB:
      return 'Labor';
    case AddressDtoAddressType.CONTACT_REFERENCE_PERSON:
      return 'Bezugsperson';
  }
}

export function getAddressReferenceTypeGroupName(type: PatientAddressDtoReferenceType) {
  switch (type) {
    case PatientAddressDtoReferenceType.NONE:
      return '-';
    case PatientAddressDtoReferenceType.PATIENT_NOTE:
      return 'Notiz';
    case PatientAddressDtoReferenceType.PATIENT_RESIDENCE:
      return 'Wohnort';
    case PatientAddressDtoReferenceType.PATIENT_GENERAL_DOCTOR:
      return 'Hausarzt';
    case PatientAddressDtoReferenceType.ANAMNESIS_DOCTOR:
      return 'Anamnese';
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_DOCTOR:
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_CANTON_DOCTOR:
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_LABORATORY:
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_TREATING_DOCTOR:
      return 'MKB';
    case PatientAddressDtoReferenceType.LABORATORY_REPORT_LABORATORY:
      return 'MLB';
    case PatientAddressDtoReferenceType.TESTRESULT_FINDINGS_DOCTOR:
    case PatientAddressDtoReferenceType.TESTRESULT_XRAY:
      return 'Testresultat';
    case PatientAddressDtoReferenceType.PATIENT_HOSPITAL:
    case PatientAddressDtoReferenceType.PATIENT_ISOLATION:
    case PatientAddressDtoReferenceType.THERAPY_DOT_APPLICANT:
    case PatientAddressDtoReferenceType.THERAPY_DOT_EXECUTOR:
    case PatientAddressDtoReferenceType.THERAPY_PHASE_1:
    case PatientAddressDtoReferenceType.THERAPY_PHASE_2:
    case PatientAddressDtoReferenceType.THERAPY_END_REFERRAL:
      return 'Therapie';
    case PatientAddressDtoReferenceType.CONTACT_PATIENT_REFERENCE_PERSON:
      return 'Bezugsperson';
  }
}

export function getAddressReferenceTypeNameForNetworkTable(type: PatientAddressDtoReferenceType) {
  switch (type) {
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_CANTON_DOCTOR:
      return 'Kantonsarzt';
    case PatientAddressDtoReferenceType.CLINICAL_REPORT_TREATING_DOCTOR:
      return 'Behandelnder Arzt';
    case PatientAddressDtoReferenceType.PATIENT_HOSPITAL:
      return 'Hospitalisation';
    case PatientAddressDtoReferenceType.PATIENT_ISOLATION:
      return 'Isolation';
    case PatientAddressDtoReferenceType.THERAPY_PHASE_1:
      return 'Therapie Phase 1';
    case PatientAddressDtoReferenceType.THERAPY_PHASE_2:
      return 'Therapie Phase 2';
    case PatientAddressDtoReferenceType.THERAPY_END_REFERRAL:
      return 'Überweisung Therapie-Ende';
    default:
      return null;
  }
}

export function isPrivateAddressType(type: AddressDtoAddressType | null) {
  switch (type) {
    case AddressDtoAddressType.ACCOMMODATION_PRIVATE:
    case AddressDtoAddressType.RELATIVE:
    case AddressDtoAddressType.CONFIDANT:
    case AddressDtoAddressType.CONTACT_REFERENCE_PERSON:
      return true;
    default:
      return false;
  }
}
